<template>
    <SideNav ref="sidenav" :check-close="onCheckClose" :check-page-close="onCheckPageClose" class="product-wizard">
        <div class="header header-wizard">
            <div class="corner">
                <div class="corner-inner">
                    <div class="wizard-container">
                        <Stepper v-model="step"
                                 :options="steps"
                                 class="stepper"
                                 @forward="step = $event.id"
                        />
                        <div class="step">
                            Шаг {{ step }} из {{ steps.length }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="adhoc">
                <div class="adhoc-wrapper">
                    <div class="adhoc-content">
                        <div class="close" @click="$refs.sidenav.cancel()"></div>
                    </div>
                </div>
            </div>
        </div>

        <component :is="currentStep[step]"
                   :add-contact-initially="false"
                   :last="step === steps.length"
                   :loading="loading"
                   :required-contacts="false"
                   :value="value[step]"
                   class="wizard-step side-nav-inner"
                   show-inform
                   @back="onBack"
                   @changed="changed = true"
                   @close="$refs.sidenav.cancel()"
                   @next="onNext"
        />

        <div v-if="confirmPublish" class="confirm">
            <div class="container">
                <div class="title">
                    Ваша заявка на добавление продукта
                    <router-link :to="{ name: 'product', params: { id: createdProductId } }" class="accent"
                                 @click.native="close">
                        {{ value[1].name }}
                    </router-link>
                    отправлена на проверку
                </div>
                <div class="message">
                    С вами свяжется контент-менеджер для уточнения информации
                </div>
                <div class="buttons">
                    <input class="ghost cancel"
                           type="button"
                           value="Перейти на главную"
                           @click="goToHome"
                    >
                </div>
            </div>
        </div>
    </SideNav>
</template>

<script>
import { documentsMap, getDocumentChanged } from '@/common/page_comp/Documents/fileApi.js';
import { currentUser } from '@/common/session.js';
import { updateInfoList } from '@/restapi/document/document.js';
import { DRAFT_STAGE_DICT } from '@/common/page_comp/Draft/draft.stage.dict.js';
import { save as saveContact } from '@/restapi/contact/contact.dict.js';
import { saveProduct } from '@/restapi/product/product.js';
import { showError } from '@dsee/components/popups/message.js';
import { newToast } from '@dsee/components/popups/toast.js';

import CreateContacts from '../common/CreateContacts.vue';
import CreateDocuments from '../common/CreateDocuments.vue';
import CreateMainInfo from './CreateMainInfo.vue';

import '@/common/page_comp/CreateCard/common/style.scss';


export default {
    components: {
        CreateMainInfo,
        CreateDocuments,
        CreateContacts,
    },
    computed: {
        currentStep() {
            return {
                1: 'CreateMainInfo',
                2: 'CreateDocuments',
                3: 'CreateContacts',
            };
        },
    },
    data() {
        return {
            value: {
                1: {},
                2: {},
                3: {},
            },

            step: 1,
            steps: [],

            changed: false,
            loading: false,
            confirmPublish: false,

            createdProductId: null,
            createdProductReqt: null,
        };
    },
    methods: {
        reset() {
            this.value = {
                1: {},
                2: {},
                3: {},
            };
            this.changed = false;
            this.confirmPublish = false;
            this.steps = [
                { id: 1, complete: false, disabled: false },
                { id: 2, complete: false, disabled: true },
                { id: 3, complete: false, disabled: true },
            ];
            this.step = 0;
            // тупо кастыль
            this.$nextTick(() => {
                this.step = 1;
            });
        },
        open() {
            this.reset();
            return this.$refs.sidenav.open();
        },
        close() {
            this.$refs.sidenav.accept();
        },
        onCheckClose(sidenav) {
            if (!this.changed)
                return true;

            return sidenav.showConfirm();
        },
        onBack(state) {
            Object.assign(this.value[this.step], state);

            this.step--;
        },
        onNext(state) {
            Object.assign(this.value[this.step], state);

            if (this.step === 3) {
                this.onCreate();
                return;
            }

            const stepIndex = this.step - 1;

            this.steps[stepIndex].complete = true;
            this.steps[stepIndex + 1].disabled = false;
            this.step++;
        },
        async onCreate() {
            this.loading = true;

            try {
                // Сохраняем документы
                const documents = [];
                const documentGroups = [];

                try {
                    for (const it of this.value[2].documents) {
                        documents.push({ ...it.value, id: it.id, accessType: 'PUBLIC' });
                    }

                    for (const it of this.value[2].documentGroups) {
                        const documents = it.value.documents.map((it) => it.id);

                        documentGroups.push({
                            ...it.value,
                            documents,
                            accessType: 'PUBLIC',
                        });
                    }

                    // сохраняем обновлённую информацию о документах
                    const documentUpdateInfo = getDocumentChanged({
                        documents: this.value[2].documents,
                        documentGroups: this.value[2].documentGroups,
                    });
                    if (documentUpdateInfo.length)
                        await updateInfoList(documentsMap(documentUpdateInfo));
                } catch (e) {
                    showError('Произошла ошибка при сохранении документов <br>' + e);
                    throw e;
                }

                // Сохраняем контакты
                const contacts = [];
                try {
                    // ВП указан как основной контакт
                    contacts.push({
                        type: 'USER',
                        main: true,
                        contact: currentUser().id,
                    });

                    for (const it of this.value[3].contacts) {
                        const contact = { ...it.contact };

                        if (contact.id === currentUser().id)
                            continue;

                        if (contact.id === -1) {
                            contact.id = null;
                            it.contact.id = await saveContact(contact);
                        }

                        contacts.push({ ...it, contact: it.contact.id });
                    }
                } catch (e) {
                    showError('Произошла ошибка при сохранении контактов <br>' + e);
                    throw e;
                }

                const main = this.value[1];

                // Сохраняем продукт
                try {
                    const reqt = {
                        ...main,
                        documents,
                        documentGroups,
                        contacts,
                        draftStage: DRAFT_STAGE_DICT.request,
                    };

                    this.createdProductId = await saveProduct(reqt);
                    this.createdProductReqt = reqt;

                    newToast('Заявка на создание продукта успешно добавлена');
                    this.confirmPublish = true;
                } catch (e) {
                    showError('Произошла ошибка при создании заявки <br>' + e.message);
                    throw e;
                }
            } finally {
                this.loading = false;
            }
        },
        onCheckPageClose() {
            if (!this.changed || this.confirmPublish)
                return;

            const confirmation = confirm('Вы действительно хотите закрыть эту вкладку?');
            if (confirmation) {
                window.close();
            } else {
                event.preventDefault();
            }
        },
        goToHome() {
            if (this.$route.name !== 'home') {
                this.$router.push({ name: 'home' });
            } else {
                this.$router.go(0);
            }

            this.close();
        },
    },
};
</script>

<style lang="scss" scoped>
.product-wizard {
    width: 962px;
    @media (max-device-width: 767px) {
        width: 100vw;
    }

    .wizard-container {
        height: 48px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);

        display: flex;
        align-items: center;
        padding: 16px 32px;
        box-sizing: border-box;

        .stepper {
            flex-grow: 2;
            margin-right: 32px;
        }

        .step {
            color: rgba(131, 137, 151, 1);
            font-size: 12px;
            line-height: 16px;
            font-weight: 400;
        }
    }

    .confirm {
        .container {
            max-width: none;
        }

        .title {
            max-width: 378px;
        }

        .message {
            max-width: 378px;
        }
    }
}
</style>

<style lang="scss">
.tooltip.tooltip-select.inform {
    padding: 0;
    background-color: #fff;

    .action {
        display: flex;
        width: 100%;
        border: none;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        padding-left: 12px;

        &:hover {
            background: var(--option-hover-background)
        }
    }
}
</style>
